import { render, staticRenderFns } from "./callinfo.vue?vue&type=template&id=41a4310a&scoped=true&"
import script from "./callinfo.vue?vue&type=script&lang=js&"
export * from "./callinfo.vue?vue&type=script&lang=js&"
import style0 from "./callinfo.vue?vue&type=style&index=0&id=41a4310a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a4310a",
  null
  
)

export default component.exports